import { render, staticRenderFns } from "./PopulationValue.vue?vue&type=template&id=247be502&"
import script from "./PopulationValue.vue?vue&type=script&lang=js&"
export * from "./PopulationValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports